<!--
 * @Descripttion: 报表属性设置
 * @Author: zenghua.wang
 * @Date: 2021-05-06 09:59:15
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-25 10:19:19
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <!-- 接口设置 -->
    <api-interface
      :data="data"
      :apis="main.apiTableList"
    >
      <template v-slot:extend>
        <el-form-item label="选择字段">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="onSetting"
          >选择</el-button>
        </el-form-item>

        <div style="margin: 8px 0">
          <el-table
            :data="data.option.column"
            v-loading="waitting"
            border
            size="small"
            style="width: 100%"
          >
            <el-table-column label="字段名">
              <template slot-scope="scope">
                {{ scope.row.prop }}
                <span v-if="scope.row.label">（{{ scope.row.label }}）</span>
              </template>
            </el-table-column>

            <el-table-column
              fixed="right"
              label="操作"
              width="140"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  icon="el-icon-top"
                  @click="sortField(scope.row, scope.$index, 'up')"
                ></el-button>
                <el-button
                  type="text"
                  size="small"
                  icon="el-icon-bottom"
                  @click="sortField(scope.row, scope.$index, 'down')"
                ></el-button>
                <el-button
                  type="text"
                  size="small"
                  icon="el-icon-edit"
                  @click="editField(scope.row, scope.$index)"
                ></el-button>
                <el-button
                  type="text"
                  size="small"
                  icon="el-icon-delete"
                  @click="deleteField(scope.row, scope.$index)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 弹窗 -->
        <report-dialog
          ref="reportDialog"
          :loading="loading"
          :dialog="dialog"
          :data="data"
          :column="column"
          @change="updateField"
        />

        <config-filter :data="data" />
      </template>
    </api-interface>

    <!-- 表格设置 -->
    <el-collapse-item title="列表设置">
      <el-form-item label="表格大小">
        <el-radio-group
          v-model="data.option.size"
          size="mini"
        >
          <el-radio-button
            v-for="(item, index) in options.sizeList"
            :key="index"
            :value="item"
            :label="item"
          ></el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="表格样式">
        <el-checkbox-group
          v-model="options.tableStyle"
          size="mini"
          @change="onTableStyleChange"
        >
          <el-checkbox-button
            v-for="(item, index) in options.styleList"
            :key="index"
            :value="item"
            :label="item"
          ></el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>

      <!-- <el-form-item label="对齐方式">
        <el-radio-group v-model="data.option.align" size="mini">
          <el-radio-button
            v-for="(item, index) in options.alignList"
            :key="index"
            :value="item.value"
            :label="item.value"
            >{{ item.label }}</el-radio-button
          >
        </el-radio-group>
      </el-form-item> -->

      <!-- <el-form-item label="固定表头">
        <el-switch
          v-model="options.fixedTable"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        >
        </el-switch>
      </el-form-item>

      <el-form-item label="表格高度">
        <el-input v-model="data.option.height"></el-input>
        <div class="xa-form-tips">输入值为 auto 或者数字</div>
      </el-form-item>-->

      <el-form-item label="显示序号">
        <el-switch
          v-model="data.option.index"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="多选">
        <el-switch
          v-model="data.option.selection"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>

      <el-form-item label="是否分页">
        <el-switch
          v-model="data.option.page"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
          @change="setPage"
        >
        </el-switch>
      </el-form-item>

      <el-form-item
        label="可选范围"
        v-if="data.option.page"
      >
        <avue-array
          size="small"
          v-model="data.page.pageSizes"
          placeholder="请输入"
        ></avue-array>
      </el-form-item>

      <el-form-item
        label="默认条数"
        v-if="data.option.page"
      >
        <el-select
          v-model="data.page.pageSize"
          placeholder="请选择"
        >
          <el-option
            v-for="item in data.page.pageSizes"
            :key="`pageSize-${item}`"
            :label="`${item}条/页`"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-collapse-item>

    <!-- 标题设置 -->
    <el-collapse-item title="标题设置">
      <el-form-item label="标题">
        <el-input
          v-model="data.option.title"
          clearable
          placeholder="请输入"
        ></el-input>
      </el-form-item>

      <el-form-item label="字体颜色">
        <el-color-picker
          v-model="data.option.titleColor"
          :predefine="predefineColors"
        ></el-color-picker>
      </el-form-item>

      <el-form-item label="字体大小">
        <el-input-number
          v-model="data.option.titleFontSize"
          placeholder="请输入"
        >
        </el-input-number>
      </el-form-item>

      <el-form-item label="字体粗细">
        <el-select
          v-model="data.option.titleFontWeight"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in weightList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-collapse-item>

    <!-- 操作按钮 -->
    <el-collapse-item title="操作按钮">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="addButton"
      >新增</el-button>
      <div style="margin: 10px 0">
        <el-table
          :data="data.option.buttons"
          v-loading="waitting2"
          border
          size="small"
          style="width: 100%"
        >
          <el-table-column
            label="按钮名称"
            prop="name"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="按钮类型"
            prop="position"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-for="(item,index) in options.buttonPosition"
                :key="index"
              >
                {{ scope.row.position == item.value ? item.label : ''}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="按钮标识"
            prop="tag"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="PC样式"
            prop="style"
            align="center"
          >
            <template slot-scope="scope">
              <span
                v-for="(item,index) in options.buttonType"
                :key="index"
              >
                {{ scope.row.style == item.value ? item.label : ''}}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            label="按钮icon"
            prop="icon"
            width="140"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="click事件"
            prop="fun"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="弹框高度"
            prop="height"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="显示条件表达式"
            min-width="200"
            prop="condition"
            align="center"
          >
            <template slot-scope="scope">
              {{scope.row.condition ? scope.row.condition : 'true'}}
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            width="140"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                icon="el-icon-top"
                @click="sortButton(scope.row, scope.$index, 'up')"
              ></el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-bottom"
                @click="sortButton(scope.row, scope.$index, 'down')"
              ></el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-edit"
                @click="editButton(scope.row, scope.$index)"
              ></el-button>
              <el-button
                type="text"
                size="small"
                icon="el-icon-delete"
                @click="deleteButton(scope.row, scope.$index)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 弹窗 -->
      <report-button
        :title="button.title"
        :show.sync="button.show"
        :row="button.row"
        :index="button.index"
        :data="data"
        @change="updateButton"
      />

      <el-form-item label="列显影">
        <el-switch
          v-model="data.option.columnBtn"
          :active-color="theme.active"
          :inactive-color="theme.inactive"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </el-collapse>
</template>
<script>
import {
  component,
  reportConfig,
  theme,
  predefineColors
} from '@/dragComponents/model/default.js'
import { isEmpty, deepClone } from '@/dragComponents/utils'
import apiField from '@/dragComponents/mixins/apiField.js'

import configBase from '@/dragComponents/config/common/base.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'
import configFilter from '@/dragComponents/config/common/filter.vue'
import apiInterface from '@/dragComponents/config/api/index.vue'
import reportDialog from './dialog.vue'
import reportButton from './button.vue'

export default {
  name: 'config-report',
  mixins: [apiField],
  components: {
    configBase,
    configAuth,
    configFilter,
    apiInterface,
    reportDialog,
    reportButton
  },
  inject: ['main', 'category'],
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      component: component,
      weightList: component.weightType,
      predefineColors: predefineColors,
      waitting2: false,
      // 操作按钮
      button: {
        title: null,
        show: false,
        index: null,
        row: {}
      },
      options: {
        sizeList: ['medium', 'small', 'mini'],
        styleList: ['边框', '条纹'],
        tableStyle: [],
        alignList: component.alignType,
        fixedTable: false,
        buttonPosition: [
          {
            label: '表头',
            value: 'header'
          },
          {
            label: '行内',
            value: 'row'
          }
        ],
        buttonType: [
          {
            label: '文字按钮',
            value: 'text'
          },
          {
            label: '主要按钮',
            value: 'primary'
          },
          {
            label: '成功按钮',
            value: 'success'
          },
          {
            label: '信息按钮',
            value: 'info'
          },
          {
            label: '警告按钮',
            value: 'warning'
          },
          {
            label: '危险按钮',
            value: 'danger'
          }
        ]
      }
    }
  },
  watch: {
    'data.prop': {
      handler() {
        if (!isEmpty(this.data.apiId)) {
          this.loadFeild()
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    setPage() {
      this.data.page.total = this.data.option.page ? 1 : 0
    },
    onSetting() {
      this.addField(deepClone(reportConfig.column))
    },
    initData() {
      // 属性设置
      if (this.data.option.border) this.options.tableStyle.push('边框')
      if (this.data.option.stripe) this.options.tableStyle.push('条纹')
    },
    onTableStyleChange(arr) {
      // 条纹
      if (arr.includes('条纹')) {
        this.data.option.stripe = true
      } else {
        this.data.option.stripe = false
      }
      // 边框
      if (arr.includes('边框')) {
        this.data.option.border = true
      } else {
        this.data.option.border = false
      }
    },
    // 操作按钮
    addButton() {
      this.button.row = {
        name: '',
        position: 'row', // 行内(row)、表头(header)
        direction: 'bottom', // 移动端按钮位置
        device: '', // 两端显示
        tag: '',
        style: 'text',
        icon: '',
        fun: 'openURL', // dialog、openURL、interface、import、export、event
        formatter: '', // 自定义事件方法
        condition: '',
        url: '',
        reqMethod: 'GET',
        params: [],
        fullscreen: '否',
        title: '',
        width: '60%',
        height: '90vh',
        tips: '',
        confirm: '',
        cancel: ''
      }
      this.button.title = '新增'
      this.button.show = true
    },
    sortButton(row, index, direction) {
      let len = this.data.option.buttons.length
      let stop = direction === 'up' ? 0 : len - 1
      if (index === stop) return
      let next = direction === 'up' ? index - 1 : index + 1
      this.waitting2 = true
      let temp = this.data.option.buttons[next]
      this.$set(this.data.option.buttons, index, temp)
      this.$set(this.data.option.buttons, next, row)
      setTimeout(() => {
        this.waitting2 = false
      }, 500)
    },
    editButton(row, index) {
      this.button.title = '编辑'
      this.button.row = row
      this.button.index = index
      this.button.show = true
    },
    updateButton(row, index) {
      if (this.button.title === '新增') {
        this.data.option.buttons.push(row)
      } else {
        this.$set(this.data.option.buttons, index, row)
      }
    },
    deleteButton(row, index) {
      let list = this.data.option.buttons.filter((item) => {
        return item !== row
      })
      this.$set(this.data.option, 'buttons', list)
    }
  },
  mounted() {
    this.initData()
  }
}
</script>
